import shipmtReptFieldsArr from './shipmtReptFieldsArr';
import tpReqPymtReptFieldsArr from './tpReqPymtReptFieldsArr';
import custReqReptFieldsArr from './custReqReptFieldsArr';
import trkOpReqReptFieldsArr from './trkOpReqReptFieldsArr';

// Report types supported by the SA report configuration module.
export const reportTypeArr = [
    { value: "shipment", label: "Shipment Report" },
    { value: "tpReqPymt", label: "Truck Operator Req Payment Report" },
    { value: "custReq", label: "Customer Request Report" },
    { value: "trkOpReq", label: "Truck Request Report" },
];

export function getReportTypeLabel(type) {
    return reportTypeArr.find((i) => i.value === type)?.label || type || "Shipment Report";
}

// Available-field catalogue per report type.
export function getReportFields(type) {
    switch (type) {
        case "tpReqPymt": return tpReqPymtReptFieldsArr;
        case "custReq": return custReqReptFieldsArr;
        case "trkOpReq": return trkOpReqReptFieldsArr;
        default: return shipmtReptFieldsArr;
    }
}
